let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lsloj")).then(() => parcelRequire('lT2Hu'));